// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2f2ND","validationTips":"StatementDescriptor_validationTips__c15uO"};